import * as v from 'valibot';
import { authorSchema, faqSchema } from '../base/schema';
import { structuredContentDocumentSchema } from '../structuredContent/schema';
import { nulltoOptional } from '../utils/validation-utils';
import { allStates, MarketplaceProductTypeEnum } from './constants';
import { EntityPlacementCtaTypeEnum, MarketplaceEntityTypeEnum, MonetizableEnum } from './enums';
import { type StateAbbreviation } from './types';

export const marketplaceProductTypeSchema = v.enum(MarketplaceProductTypeEnum);
export const entityPlacementCtaTypeSchema = v.enum(EntityPlacementCtaTypeEnum);
export const monetizableSchema = v.enum(MonetizableEnum);
export const entityTypeSchema = v.pipe(
  v.string(),
  v.transform(val => val.toLowerCase()),
  v.enum(MarketplaceEntityTypeEnum),
);

export const DriverSchema = v.object({
  id: v.string(),
  description: nulltoOptional(v.string()),
  label: v.string(),
  labelTooltip: nulltoOptional(v.string()),
  value: nulltoOptional(v.string()),
  valueTooltip: nulltoOptional(v.string()),
});

export const stateSchema = v.custom<StateAbbreviation>(val => {
  const response = v.safeParse(v.picklist(allStates), val);
  if (response.success) {
    return true;
  }
  throw new Error(`Unsupported state: ${val}`);
});

export const statesSchema = nulltoOptional(v.array(stateSchema));

export const recapItemSchema = v.object({
  recapDescription: nulltoOptional(v.string()),
  marketplaceEntity: v.object({
    id: v.string(),
    name: v.string(),
    displayName: nulltoOptional(v.string()),
    monetizable: nulltoOptional(monetizableSchema),
    reviewLink: nulltoOptional(v.string()),
    states: statesSchema,
  }),
});

export const recapListSectionSchema = v.object({
  title: v.string(),
  recapItems: nulltoOptional(v.array(recapItemSchema)),
});

export const belowSectionsSchema = v.object({
  belowSections: nulltoOptional(structuredContentDocumentSchema),
  modifiedAtFormatted: nulltoOptional(v.string()),
  methodology: nulltoOptional(structuredContentDocumentSchema),
  authors: v.array(authorSchema),
  faqs: nulltoOptional(v.array(faqSchema)),
  recapListSection: nulltoOptional(recapListSectionSchema),
});

export const ctaSchema = v.object({
  link: v.string(),
  showIcon: v.fallback(v.boolean(), false),
  subtext: nulltoOptional(v.string()),
  text: v.string(),
  type: entityPlacementCtaTypeSchema,
});

export const bestOfAwardsSchema = v.array(
  v.object({
    year: v.number(),
    category: v.string(),
  }),
);
